import { Link } from "react-router-dom";
import change from "../../assets/images/homeee.png";
import banner from "../../assets/images/logo-white.svg";
import karimjee from "../../assets/images/blue_logo.png";
import autoline from "../../assets/images/autolin.png";

export default function Change() {
  return (
    <div className="">
      <div className="bg-karimjee flex justify-center items-center w-full py-2 h-20">
        <img src={banner} alt="" className="w-32" />
      </div>
      <div className="flex flex-col justify-center items-center mt-8">
        <img src={change} alt="" width={"600"} />
        <div className="flex justify-center items-center mt-4">
          <Link
            to={"/signin?redirect=/change/requests"}
            className="bg-gradient-to-r from-karimjee-dark to-karimjee text-white text-center font-semibold w-64 py-4  rounded-lg shadow-md hover:shadow-lg hover:from-blue-800 hover:to-blue-900 transition-all duration-200 mx-1"
          >
            <div className="flex flex-col items-center justify-center">
              <div className="bg-white px-4 py-2 rounded-lg mb-2">
                <img src={karimjee} alt="Logo" height={15} width={100} />
              </div>
              Change Request Form
            </div>
          </Link>
          <Link
            to={"/signin?redirect=/autoline/dashboard"}
            className="bg-gradient-to-r from-karimjee-dark to-karimjee text-white text-center font-semibold w-64 py-4 rounded-lg shadow-md hover:shadow-lg hover:from-blue-900 hover:to-blue-800 transition-all duration-200 mx-1"
          >
            <div className="flex flex-col items-center justify-center">
              <div className="bg-white px-4 py-2 rounded-lg mb-2">
                <img src={autoline} alt="Logo" height={15} width={150} />
              </div>
              Autoline Access Request
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
